/**
 * Template Name: eNno - v2.1.0
 * Template URL: https://bootstrapmade.com/enno-free-simple-bootstrap-template/
 * Author: BootstrapMade.com
 * License: https://bootstrapmade.com/license/
 */
;(function ($) {

  if (!$) {
    return
  }

  // Smooth scroll for the navigation menu and links with .scrollto classes
  var scrolltoOffset = $("#header").outerHeight() - 16
  if (window.matchMedia("(max-width: 991px)").matches) {
    scrolltoOffset += 16
  }
  $(document).on(
    "click",
    ".nav-menu a, .mobile-nav a, .scrollto",
    function (e) {
      if (
        window.location.pathname.replace(/^\//, "") ===
        this.pathname.replace(/^\//, "") &&
        window.location.hostname === this.hostname
      ) {
        e.preventDefault()
        var target = $(this.hash)
        if (target.length) {
          var scrollto = target.offset().top - scrolltoOffset

          if ($(this).attr("href") === "#header") {
            scrollto = 0
          }

          $("html, body").animate(
            {
              scrollTop: scrollto,
            },
            1500,
            "easeInOutExpo"
          )

          if ($(this).parents(".nav-menu, .mobile-nav").length) {
            $(".nav-menu .active, .mobile-nav .active").removeClass("active")
            $(this).closest("li").addClass("active")
          }

          if ($("body").hasClass("mobile-nav-active")) {
            $("body").removeClass("mobile-nav-active")
            $(".mobile-nav-overly").fadeOut()
          }
          return false
        }
      }
    }
  )

  // Activate smooth scroll on page load with hash links in the url
  $(document).ready(function () {
    if (window.location.hash) {
      var initial_nav = window.location.hash
      if ($(initial_nav).length) {
        var scrollto = $(initial_nav).offset().top - scrolltoOffset
        $("html, body").animate(
          {
            scrollTop: scrollto,
          },
          1500,
          "easeInOutExpo"
        )
      }
    }
  })

  // Mobile Navigation
  if ($(".nav-menu").length) {
    var $mobile_nav = $(".nav-menu").clone().prop({
      class: "mobile-nav d-lg-none",
    })
    $("body").append($mobile_nav)
    // $("body").prepend(
    //   '<button type="button" class="mobile-nav-toggle d-lg-none"><i class="bx bx-menu"></i></button>'
    // )
    $("body").append('<div class="mobile-nav-overly"></div>')
    // The above line has been added so that when the user clicks the cross button on the top banner, 
    // the hamburger icon should also move up so that it's aligned with the header. 
    // We had to touch this generated jquery code because the hamburger was auto-generated by the gatsbyjs.
    $(document).on("click", ".mobile-nav-toggle", function (e) {
      $("body").toggleClass("mobile-nav-active")
      $(".mobile-nav-overly").toggle()
    })

    $(document).on("click", ".mobile-nav .drop-down > a", function (e) {
      e.preventDefault()
      $(this).next().slideToggle(300)
      $(this).parent().toggleClass("active")
    })

    $(document).click(function (e) {
      var container = $(".mobile-nav, .mobile-nav-toggle")
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if ($("body").hasClass("mobile-nav-active")) {
          $("body").removeClass("mobile-nav-active")
          $(".mobile-nav-overly").fadeOut()
        }
      }
    })
  } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
    $(".mobile-nav, .mobile-nav-toggle").hide()
  }

  // Navigation active state on scroll
  var nav_sections = $("section")
  var main_nav = $(".nav-menu, #mobile-nav")

  $(window).on("scroll", function () {
    var cur_pos = $(this).scrollTop() + 200

    nav_sections.each(function () {
      var top = $(this).offset().top,
        bottom = top + $(this).outerHeight()

      if (cur_pos >= top && cur_pos <= bottom) {
        if (cur_pos <= bottom) {
          main_nav.find("li").removeClass("active")
        }
        main_nav
          .find('a[href="#' + $(this).attr("id") + '"]')
          .parent("li")
          .addClass("active")
      }
      if (cur_pos < 300) {
        $(".nav-menu ul:first li:first").addClass("active")
      }
    })
  })

  // Toggle .header-scrolled class to #header when page is scrolled
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $("#header").addClass("header-scrolled")
    } else {
      $("#header").removeClass("header-scrolled")
    }
  })

  if ($(window).scrollTop() > 100) {
    $("#header").addClass("header-scrolled")
  }

  // Back to top button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".back-to-top").fadeIn("slow")
    } else {
      $(".back-to-top").fadeOut("slow")
    }
  })

  $(".back-to-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1500,
      "easeInOutExpo"
    )
    return false
  })

  // Removed plugin init for counterUp / isotope / venobox / owlCarousel —
  // those plugins are no longer bundled (see gatsby-browser.js) and their
  // target selectors (.testimonials-carousel, .portfolio-container, .venobox,
  // [data-toggle="counter-up"]) are not used anywhere in the React tree.

})(window.jQuery)
